// btc15/study.js — the study's "already decided" curve, as the desk has it.
//
// P(final direction == direction at minute m), from the 2,999-window study
// behind this desk. Mirrors KNOWN_SO_FAR in backend/btc15_desk.py and is
// checked against it by deskmath.mirror.test.js.
//
// Before 2026-09-16's audit the tab's Decided indicator drew a made-up curve
// (0.5 + 0.5·t^2.1) that read 71% at minute 10 where the study says 82%.
// The readout beside it was right and the picture was wrong, which is the
// worst combination: it looks checked. Everything now draws from this table.
export const KNOWN_SO_FAR = { 0: 50, 1: 63, 3: 69, 5: 73, 8: 79, 10: 82, 12: 87, 13: 91, 14: 100 };

const KEYS = Object.keys(KNOWN_SO_FAR).map(Number).sort((a, b) => a - b);

/** The study's figure at any minute, linearly interpolated between the
 *  measured points and held flat at 100 past minute 14. As a fraction. */
export function knownSoFarAt(minute) {
  const m = Math.max(0, Math.min(15, Number(minute) || 0));
  if (m >= KEYS[KEYS.length - 1]) return KNOWN_SO_FAR[KEYS[KEYS.length - 1]] / 100;
  let lo = KEYS[0];
  for (const k of KEYS) { if (k <= m) lo = k; else break; }
  const hi = KEYS[KEYS.indexOf(lo) + 1];
  if (hi == null) return KNOWN_SO_FAR[lo] / 100;
  const t = (m - lo) / (hi - lo);
  return (KNOWN_SO_FAR[lo] + t * (KNOWN_SO_FAR[hi] - KNOWN_SO_FAR[lo])) / 100;
}
